import { render, staticRenderFns } from "./notice_list.vue?vue&type=template&id=74b74e9e&scoped=true&"
import script from "./notice_list.vue?vue&type=script&lang=js&"
export * from "./notice_list.vue?vue&type=script&lang=js&"
import style0 from "./notice_list.vue?vue&type=style&index=0&id=74b74e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b74e9e",
  null
  
)

export default component.exports